import denominationEditComponent from './denomination.edit.component';
import './denomination.edit.scss';

let denominationEditModule = angular.module('denominationedit', [
])

.component('denominationedit', denominationEditComponent)

.name;

export default denominationEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/edit/index.js